import {gt} from '@naverpay/hidash/gt'
import {lt} from '@naverpay/hidash/lt'

export const gtZero = (value: number) => gt(value, 0)
export const ltZero = (value: number) => lt(value, 0)

// 반환되는 수가 음수인 경우 0이 반한되도록 합니다.
export const minZero = (value: number) => Math.max(value, 0)

/** 0인 경우에 true를 반환합니다 */
export const isZero = (value: number) => value === 0
